import { cn } from "@/frontend/lib/utils";

type QuerygenMarkProps = {
  className?: string;
};

export function QuerygenMark({ className }: QuerygenMarkProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#15221b] text-[22px] font-normal leading-none text-[#d7ff64] font-logo",
        className,
      )}
    >
      Q
    </span>
  );
}
